astral-breadcrumb {
  nav {
    display: inline-flex;
  }
}